/**
 * Contrato comum dos arranjos da tela do totem.
 *
 * A lógica (digitação, busca, inatividade, teclado físico) mora em Autoatendimento.tsx e é
 * a mesma para todos. Cada arranjo só decide como aquilo aparece — trocar de layout não
 * pode mudar o que o totem faz.
 */
export interface PropsLayoutTotem {
  logo: string | null
  nomeEvento: string
  /** "CPF", "CNPJ" ou "CPF ou CNPJ" — vem dos documentos aceitos pelo evento. */
  rotulo: string
  instrucao: string
  /** Já formatado; string vazia quando nada foi digitado. */
  documento: string
  /** Exemplo do formato esperado, mostrado no visor vazio. */
  mascara: string
  erro: string | null
  buscando: boolean
  onTecla: (t: string) => void
  cores: { primaria: string; secundaria: string; destaque: string }
}

/**
 * A tecla de ação é um símbolo, não o texto do botão: cada arranjo escreve o rótulo que
 * usa ("Avançar", "Buscar"), e o tratamento da tecla não depende dessa escolha visual.
 */
export const ACAO = '#acao'
export const APAGAR = '⌫'

export const TECLAS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', APAGAR, '0', ACAO]
